/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionClient,
  RemoteSessionClient$inboundSchema,
} from "./remotesessionclient.js";

/**
 * An organization-administrator view of a remote_session_client: the client plus the number of MCP servers it is attached to and the number of active sessions minted against it.
 */
export type OrganizationRemoteSessionClient = {
  /**
   * Number of non-deleted (active) remote_sessions minted against this client.
   */
  activeSessionCount: number;
  /**
   * A remote_session_client record. client_secret_encrypted is never returned.
   */
  client: RemoteSessionClient;
  /**
   * Number of non-deleted MCP servers attached to this client (via user_session_issuers).
   */
  mcpServerCount: number;
};

/** @internal */
export const OrganizationRemoteSessionClient$inboundSchema: z.ZodMiniType<
  OrganizationRemoteSessionClient,
  unknown
> = z.pipe(
  z.object({
    active_session_count: z.int(),
    client: RemoteSessionClient$inboundSchema,
    mcp_server_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "active_session_count": "activeSessionCount",
      "mcp_server_count": "mcpServerCount",
    });
  }),
);

export function organizationRemoteSessionClientFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationRemoteSessionClient, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationRemoteSessionClient$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationRemoteSessionClient' from JSON`,
  );
}
